<template>
  <el-drawer class="Academy-modal academy-article-drawer" v-model="editingOpen" :before-close="handleClose" size="60%">
    <Loading v-if="loading" class="absolute" />
    <header class="academy-header">
      <div class="header-left">
        <svg-icon name="close" class="icon-close" @click="handleClose()" />
        <h2 class="header-title">{{ drawerTitle }}</h2>
      </div>

      <div class="header-right">
        <el-dropdown
          v-if="controls.type === 2 && canSave"
          trigger="hover"
          placement="bottom-end"
          @command="onPreviewCommand"
          :teleported="true"
        >
          <span class="el-dropdown-link">
            <el-button text> Preview <i class="el-icon-arrow-down" /> </el-button>
          </span>

          <template #dropdown>
            <el-dropdown-menu class="academy-preview-dropdown">
              <el-dropdown-item command="preview">Preview</el-dropdown-item>
              <el-dropdown-item command="preview-save">Preview & Save</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <el-button text v-else-if="controls.type === 2" @click="handlePreview()">
          Preview{{ canSave ? ' & Save' : '' }}
        </el-button>

        <el-button
          text
          v-if="controls.type === 2 && ininData.status !== STATUS_CODE.Draft"
          @click="hideOrUnhideAcademy()"
        >
          <svg-icon name="eye" v-if="ruleForm.status !== STATUS_CODE.Hidden" />
          <svg-icon name="eye-hidden" v-else />
        </el-button>

        <el-button text @click="deleteThis()" v-if="!controls.is_new">
          <svg-icon name="delete2" />
        </el-button>

        <el-button type="primary" @click="handleSave()" :disabled="!canSave"> Save </el-button>

        <el-button type="primary" @click="Publish()" :disabled="!canPublish">
          {{ ininData.have_unpublished_draft && ininData.status !== STATUS_CODE.Draft ? 'Publish changes' : 'Publish' }}
        </el-button>
      </div>
    </header>

    <!-- ========== main ========== -->
    <el-scrollbar class="academy-content">
      <div class="academy-body">
        <div class="form-block-top">
          <div class="cover-block">
            <figure class="cover" @click="is_show_cropper = true">
              <img v-if="ruleForm.img.src" :src="ruleForm.img.src" />
              <div v-else class="cover-empty">
                <svg-icon name="add_box" />
                <span>Add Cover</span>
              </div>
            </figure>
          </div>

          <div class="block-right">
            <div class="title-block">
              <label class="required">Title</label>
              <el-input v-model="ruleForm.title" placeholder="Add title" maxlength="100" show-word-limit />
            </div>

            <div class="page-block">
              <label>Page</label>
              <AcadmyPickPage
                :needWait="true"
                :allPages="pageList"
                :initValue="ruleForm.creator_academy_page_text"
                :key="ruleForm.creator_academy_page_text"
                @changePage="handlePageChange"
              />
              <!-- <el-select v-model="ruleForm.page">
                <el-option label="Home" value="home" />
              </el-select> -->
            </div>
          </div>
        </div>

        <!-- Body -->
        <div class="form-block">
          <label class="required">Body</label>

          <TinymceEditor ref="editorRef" v-model="ruleForm.desc" />
        </div>
      </div>
    </el-scrollbar>
  </el-drawer>

  <!-- no cover dialog -->
  <el-dialog v-model="noCoverPublishDialogVisible" width="400px" :show-close="false" :show-header="false" class="alert-handle-dialog" append-to-body>
 
    <h3>Unable to publish article</h3>
    <div>A cover image is required to publish your article. Please upload a cover image before publishing.</div>
    <div class="btn-box">
      <el-button type="primary" @click="noCoverPublishDialogVisible = false">Ok</el-button>
    </div>
  </el-dialog>

  <!-- handle image -->
  <el-dialog v-model="is_show_cropper" title="Thumbnail" width="1000" :key="handle_clear_key">
    <UploadImage @saveAvatar="saveAvatar" :aspectRatio="1" :maxImage="5" :acceptType="'image/png, image/jpg, image/jpeg'"/>
  </el-dialog>
</template>
<script setup>
import emitter from '@/utils/EventBus';
import { ref, onMounted, onUnmounted, computed, getCurrentInstance, watch } from 'vue';
import TinymceEditor from '@/components/ui/TinymceEditor.vue';
import UploadImage from '@/components/ui/UploadImage.vue';
import { useNotification } from '@/components/ui/notification';
import { useStore } from 'vuex';
import Loading from '@/components/ui/Loading.vue';
import AcadmyPickPage from '@/components/settings/Acadmy/AcadmyPickPage.vue';
import {
  ElInput,
  ElButton,
  ElDialog,
  ElDrawer,
  ElSelect,
  ElOption,
  ElScrollbar,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
} from 'element-plus';
import { useAcadmyFunction } from '@/components/settings/Acadmy/AcadmyFunction.js';


const emit = defineEmits(['callPublish']);
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const { openNotBottom } = useNotification();
const { STATUS_CODE, DOTHING_CODE, handleObgDate, goPreview } = useAcadmyFunction();
const store = useStore();
const editingOpen = ref(false);
const pageList = ref([]);
const handle_clear_key = ref(0); //用來重置上傳圖片元件
const controls = ref({
  type: 0, //0:new 1: draft 2: published
  is_new: true, //建立和編輯的API不一樣，看這值判斷
});
const is_show_cropper = ref(false);
const noCoverPublishDialogVisible = ref(false);
const editorRef = ref(null);
const ruleForm = ref({
  img: {
    src: null,
    data: null,
  },
  title: '',
  page: 'home',
  desc: '',
  status: 'draft',
});
const copyRulForm = ref(null); //檢查資料是否有更動過
const loading = ref(false);
const ininData = ref({}); //初始載入的資料

const checkValue = computed(() => {  
  return ruleForm.value.title && ruleForm.value.desc //&& ruleForm.value.img.src;
});

const canSave = computed(() => {
  if (!checkValue.value) {
    return false;
  }
  //資料有更動過
  if (JSON.stringify(copyRulForm.value) !== JSON.stringify(ruleForm.value)) {
    return true;
  }
  return false;
});

const canPublish = computed(() => {
  if (!ruleForm.value.title || !ruleForm.value.desc) {
    return false;
  }

  if (JSON.stringify(copyRulForm.value) === JSON.stringify(ruleForm.value) && ruleForm.value.status !== STATUS_CODE.Draft) {
    return false;
  }

  return true;
});

const drawerTitle = computed(() => {
  if (controls.value.type === 0) {
    return 'New article';
  } else {
    return 'Edit Article';
  }
});

const isChangedAndCanSave = computed(() => {
  return Boolean(
    ruleForm.value.title && ruleForm.value.desc && JSON.stringify(copyRulForm.value) !== JSON.stringify(ruleForm.value)
  );
});

//+++++++++++++++++++++++++++++++++++++
// Methods
//+++++++++++++++++++++++++++++++++++++
const saveAvatar = (data) => {
  ruleForm.value.img = data;
  is_show_cropper.value = false;
};

const handlePageChange = (val) => {
  ruleForm.value.creator_academy_page_id = val.id;
  ruleForm.value.creator_academy_page_text = val.name;
};

const injectIframeSandbox = (html) => {
  if (!html) return html;
  const PERMS = 'allow-scripts allow-same-origin';
  return html.replace(/<iframe\b([^>]*)>/gi, (match, attrs) => {
    const sandboxMatch = attrs.match(/\bsandbox="([^"]*)"/i);
    if (!sandboxMatch) {
      return `<iframe sandbox="${PERMS}"${attrs}>`;
    }
    const existing = sandboxMatch[1].split(/\s+/).filter(Boolean);
    const merged = [...new Set([...existing, ...PERMS.split(' ')])];
    return match.replace(/\bsandbox="[^"]*"/i, `sandbox="${merged.join(' ')}"`);
  });
};

const handlForApiData = () => {
  let params = {
    title: ruleForm.value.title ?? '',
    body: injectIframeSandbox(ruleForm.value.desc),
    status: STATUS_CODE.Draft,//This field should always send 10 if it has been edited.
    creator_academy_page_id: ruleForm.value.creator_academy_page_id,
    plain_text_body: editorRef.value?.getContent({ format: 'text' })?.slice(0, 200) || '',
  };
  console.log('ruleForm.value.page', ruleForm.value);
  if (ruleForm.value.img.data) {
    params.cover_image_file = ruleForm.value.img.data;
  }else if( ruleForm.value.img.src ){
    params.exist_cover_image_url = ruleForm.value.img.src;
  }

  if (!controls.value.is_new) {
    params.creator_academy_article_id = ruleForm.value.id;
  }

  let formData = new FormData();

  for (const key in params) {
    if (Array.isArray(params[key])) {
      params[key].forEach((value) => {
        formData.append(`${key}[]`, value);
      });
    } else {
      formData.append(key, params[key]);
    }
  }
  return formData;
};

const handleSave = () => {
  if(ininData.value?.status === STATUS_CODE.Active){
    save();
    return;
  }

  emitter.emit('confirm-dialog', {
    type: 6,
    data: ininData.value,
  });
};

const save = async (needPublish, goPreviewFlag) => {
  if (!canSave.value) {
    if (goPreviewFlag) {
      goPreview(ruleForm.value.creator_academy_page_id, ininData.value.id, ruleForm.value.creator_academy_page_text, ruleForm.value.title);
    }
    return;
  }

  loading.value = true;
  let formData = handlForApiData('save');
  ajax
    .post('/creator-academy/save-article', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      openNotBottom('Save successful', 'success');
      //新建的需要在儲存前發布(STEP1:先傳出去問是否確認發布 STEP2:再外面呼叫近來先儲存 STEP3:再CALL發布API(在外層))
      if (needPublish) {
        emit('callPublish', res.data.data);
      }else{
        emitter.emit('refresh-academy-list');
      }
      //emitter.emit('refresh-academy-list');

      if (goPreviewFlag) {
        goPreview(ruleForm.value.creator_academy_page_id, res.data.data.id, ruleForm.value.creator_academy_page_text, ruleForm.value.title);
        ininData.value = res.data.data;
        copyRulForm.value = JSON.parse(JSON.stringify(ruleForm.value));
        return;
      }
      closeDrawer();
    })
    .catch((err) => {
      console.error('err', err);
      let err_text= 'Save failed, please try again later';
      if (err && err.response && err.response.data.data) {
         err_text = err.response.data.data.message;
      }
      openNotBottom( err_text, 'error');
    })
    .finally(() => {
      loading.value = false;
    });
};

const handleClose = () => {
  if (isChangedAndCanSave.value) {
    emitter.emit('confirm-dialog', {
      type: 5,
      data: {
        ...ruleForm.value,
        status: ruleForm.value.status,
        isFromEdit: true,
      },
    });
  } else {
    closeDrawer();
  }
};

const open = (val, outPage) => {
  pageList.value = outPage || [];
  if (val) {
    controls.value.type = 2;
    controls.value.is_new = false;
    //載入資料
    loading.value = true;
    ajax
      .get(`/creator-academy/get-article?creator_academy_article_id=${val.id}`)
      .then((res) => {
        const data = {
          ...handleObgDate(res.data.data, pageList.value),
        }
        const draftData = data.last_creator_academy_article_draft;

        ruleForm.value = {
          id:  data.id,
          img: {
            src: draftData.cover_image_url,
            data: null,
          },
          title: draftData.title || '',
          page: draftData.page,
          desc: draftData.body || '',
          status: draftData.status || STATUS_CODE.Draft,
          creator_academy_page_id: draftData.creator_academy_page_id || null,
          creator_academy_page_text: draftData.creator_academy_page_text || null,
        };
        console.log('ruleForm.value', ruleForm.value);
        copyRulForm.value = JSON.parse(JSON.stringify(ruleForm.value));
        ininData.value = data;
        editingOpen.value = true;
      })
      .catch((err) => {
        console.error('err', err);
        openNotBottom('Failed to load data, please try again later', 'error');
      })
      .finally(() => {
        loading.value = false;
      });
  } else {
    controls.value.type = 0;
    controls.value.is_new = true;
    const defaultPage = pageList.value.find((item) => item.is_default_page === 1);
    //清空資料
    ruleForm.value = {
      id: null,
      img: {
        src: null,
        data: null,
      },
      title: '',
      page: 'home',
      desc: '',
      status: STATUS_CODE.Draft,
      status_text: 'draft',
      creator_academy_page_id: defaultPage ? defaultPage.id : null,
      creator_academy_page_text: defaultPage ? defaultPage.title : null,
    };
  }
  copyRulForm.value = JSON.parse(JSON.stringify(ruleForm.value));
  editingOpen.value = true;
};

const deleteThis = () => {
  const type = ruleForm.value.status === 'Draft' ? DOTHING_CODE.DeleteDraft : DOTHING_CODE.DeleteActive;
  emitter.emit('confirm-dialog', { type, data: ruleForm.value });
};

const hideOrUnhideAcademy = async () => {
  const type = ruleForm.value.status === STATUS_CODE.Hidden ? DOTHING_CODE.Unhide : DOTHING_CODE.Hide;
  emitter.emit('confirm-dialog', { type, data: ruleForm.value });
};

const Publish = async () => {
  if (!ruleForm.value.img.src) {
    noCoverPublishDialogVisible.value = true;
    return;
  }
  emitter.emit('confirm-dialog', { type: DOTHING_CODE.Publish, data: ruleForm.value, needSave: canSave.value });
};

const closeDrawer = () => {
  editingOpen.value = false;
};

const handlePreview = () => {
  save(false, 'goPreview');
};

const onPreviewCommand = (command) => {
  if (command === 'preview') {
    goPreview(ruleForm.value.creator_academy_page_id, ininData.value.id, ruleForm.value.creator_academy_page_text, ruleForm.value.title);
  } else if (command === 'preview-save') {
    save(false, 'goPreview');
  }
};
//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(() => {});

onUnmounted(() => {});

defineExpose({
  open,
  save,
  closeDrawer,
});
</script>
<style lang="scss">
.Academy-modal {
  height: 100vh;
  .el-drawer__header {
    display: none;
  }

  .el-drawer__body {
    padding: 0 24px;
    height: 100%;
  }

  .el-scrollbar {
    height: 100%;
  }

  //header
  .academy-header {
    position: sticky;
    top: 0;
    z-index: 10050;
    background-color: #fff;
    overflow: visible;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      width: 20px;
      height: 20px;
      display: block;
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .icon-close {
        cursor: pointer;
      }

      .header-title {
        font: var(--font-med-24);
      }
    }

    .header-right {
      display: flex;
      gap: 8px;

      .el-button {
        margin: 0 !important;
      }

      .svg-icon--delete2 {
        fill: var(--red);
      }
    }
  }

  /* Ensure dropdown popper appears above drawer/scrollbar */
  .el-dropdown-menu,
  .el-popper,
  .el-popper__arrow {
    z-index: 10060 !important;
  }

  //body
  label {
    font: var(--font-med-16);

    &.required::after {
      content: '*';
      color: var(--red);
      margin-left: 4px;
    }
  }

  .form-block-top {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
    width: 100%;

    .block-right {
      display: grid;
      gap: 16px;
      flex: 1;
    }
  }

  //cover
  .form-block {
    margin-bottom: 24px;

    label {
      display: block;
      margin-bottom: 8px;

      &.required::after {
        content: '*';
        color: var(--red);
        margin-left: 4px;
      }
    }
  }

  .cover {
    width: 142px;
    height: 142px;
    border: 1px solid var(--black-40);
    background-color: var(--bg-03);
    border-radius: 6px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cover-empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #999;
      gap: 4px;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  .tinymce-editor-container {
    height: calc(100vh - 280px);

    .tox-tinymce {
      height: 100% !important;
    }
  }
}

.tox-tinymce-aux {
  z-index: 100000 !important;
}

/* preview dropdown padding reset */
.academy-preview-dropdown {
  padding: 8px  0!important;

  li{
    border-radius: 0 !important;
  }
}
</style>
